import uniqueId from 'lodash.uniqueid'

/**
 * Generate unique id for use
 * with component key etc.
 */
export const generateId = (prefix?: string) => {
  return uniqueId(prefix)
}
